<template>
  <li
    class="nav-item px-2 text"
    style="text-align: left"
  >

    <a href="#" class="nav-link">
      <i class="nav-icon fas fa-money-bill-wave"></i>
      <p>Liquidaciones<i class="fas fa-angle-left right"></i></p>
    </a>

    <ul class="nav nav-treeview pl-2">

      <li class="nav-item" v-if="showPreliminares">
        <router-link class="nav-link" to="/liquidaciones/preliminares">
          <i class="nav-icon fas fa-circle text-xs"></i>
          <p>Preliminares</p>
        </router-link>
      </li>

      <li class="nav-item" v-if="showFinales">
        <router-link class="nav-link" to="/liquidaciones/finales">
          <i class="nav-icon fas fa-circle text-xs"></i>
          <p>Finales</p>
        </router-link>
      </li>

      <li class="nav-item" v-if="showGlosas">
        <router-link class="nav-link" to="/liquidaciones/glosas">
          <i class="nav-icon fas fa-circle text-xs"></i>
          <p>Glosas</p>
        </router-link>
      </li>

      <li class="nav-item" v-if="showImportadorContenedores">
        <router-link class="nav-link" to="/liquidaciones/importador-de-contenedores">
          <i class="nav-icon fas fa-circle text-xs"></i>
          <p>Import. Contenedores</p>
        </router-link>
      </li>

    </ul>
  </li>
</template>

<script>
/**
 * @author Miguel González.
 * @description modify role structure.
 * last modified 18-04-2023 17:25
 */
// Vuex
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      current_url: "",
      seccion_aux: "",
      showPreliminares: true,
      showFinales: true,
      showGlosas: true,
      showImportadorContenedores: true,
    };
  },
  computed: {
    ...mapState(["url_actual", "seccion_actual", "sub_seccion_actual", "isAdmin", "url_actual"]),
  },
  methods: {
    ...mapActions(["AccionCambiarSeccionActual", "AccionCambiarSubseccionActual"]),

    superAdmin() {
      this.showLiquidaciones = true;
      this.showPreliminares = true;
      this.showFinales = true;
      this.showGlosas = true;
      this.showImportadorContenedores = true;
    }
  },
  watch: {
    url_actual: function (_new) {
      this.seccion_aux = _new.split("/")[1];
    },
  },

  created() {

    if(JSON.parse(localStorage.getItem('user'))?.rol === 'Super Administrador') this.superAdmin();

    const liquidationsRoleStructure = JSON.parse(localStorage.getItem('roleStructure')).find(({idModule}) => idModule === 8);

    if(liquidationsRoleStructure){

      liquidationsRoleStructure.sections.map(({ idSection }) => {

        switch (idSection) {
          case 263: this.showPreliminares = true; break;
          case 264: this.showFinales = true; break;
          case 265: this.showGlosas = true; break;
          case 266: this.showImportadorContenedores = true; break;
          default: break;
        }
      });
    }

    const liquidationsUserStructure = JSON.parse(localStorage.getItem('userStructure')).find(({idModule}) => idModule === 8);

    if(liquidationsUserStructure){

      liquidationsUserStructure.sections.map(({ idSection }) => {

        switch (idSection) {
          case 263: this.showPreliminares = true; break;
          case 264: this.showFinales = true; break;
          case 265: this.showGlosas = true; break;
          case 266: this.showImportadorContenedores = true; break;
          default: break;
        }
      });
    }
  }
};

</script>

<style>
.subMenu {
  margin-left: 8px !important;
}
</style>


